export default __webpack_public_path__ + "static/media/imageIcon2.4cf93385.svg";